import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    back: 'Back',
    delete: 'Delete item',
    errorMessage:
      'An error has occurred while deleting your item. Please try again and if the problem persists, please contact us.',
    subtitle:
      'You will no longer be able to add this item to your invoices, but existing invoices will not be modified. Are you sure you want to delete it?',
    successMessage: 'Changes successfully saved!',
    title: 'Deleting your item',
  },
  fr: {
    back: 'Retour',
    delete: 'Supprimer l’article',
    errorMessage:
      'Une erreur est survenue lors de la suppression de votre article. Réessayez et si le problème persiste, contactez-nous.',
    subtitle:
      'Vous ne pourrez plus ajouter cet article sur vos factures mais les factures existantes ne seront pas modifiées. Êtes-vous sûr·e de vouloir le supprimer ?',
    successMessage: 'Modifications enregistrées avec succès !',
    title: 'Suppression de votre article',
  },
} as const);

export default locales;
